export var ImageIconFragment = "\nfragment ImageIconFragment on Image {\n  image {\n    url\n  }\n}\n";
export var CustomIconFragment = "\n  fragment CustomIconFragment on Mailchimp {\n    embedCode\n  }\n";